import React, { FC } from 'react';

export const ChangeArrow: FC<{ up: boolean }> = ({ up }) => (
  <svg width="8" height="8" viewBox="0 0 8 8" style={{ minWidth: 8 }}>
    <polygon points={up ? '4,0 0,4.5 8,4.5' : '0,0 8,0 4,4.5'} fill={up ? '#7EDC9A' : '#E53935'} />
    <polygon points={up ? '4,4 0,8 8,8' : '0,4 8,4 4,8'} fill={up ? '#35B95A' : '#FF6B6B'} />
  </svg>
);
